import React from 'react';
import { Breadcrumb, Panel } from 'rsuite';
import PageHeader from '@/components/PageHeader';
import RunEventKeyList from './run-event-key-list';

const Page = () => {
  return (
    <Panel
      header={
        <PageHeader title="Run Events">
          <Breadcrumb>
            <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
            <Breadcrumb.Item href="/run-events">Run Events</Breadcrumb.Item>
            <Breadcrumb.Item active>Keys</Breadcrumb.Item>
          </Breadcrumb>
        </PageHeader>
      }
    >
      <RunEventKeyList />
    </Panel>
  );
};

export default Page;
